<template>
  <div class="muteComponentContainer">
    <Transition name="fade">
      <div v-if="showTooltip" class="tooltip">Click here to mute or unmute the sound</div>
    </Transition>

    <MButton
      @click="onClick"
      :title="muted ? 'Unmute Audio' : 'Mute Audio'"
      :icon="muted ? faVolumeMute : faVolumeHigh"
      :active="!muted"
    />
  </div>
</template>

<script setup lang="ts">
import { faVolumeMute, faVolumeHigh } from '@fortawesome/free-solid-svg-icons'
import { storeToRefs } from 'pinia'
import { ref, onMounted } from 'vue'
import type { Ref } from 'vue'

// Helpers
import { useTimeout } from '@/utils/helpers'

// components
import MButton from '@/components/MButton.vue'

// Stores
import { useSoundEffectsStore } from '@/stores/SoundEffectsStore'

const soundEffectsStore = useSoundEffectsStore()
const { muted } = storeToRefs(soundEffectsStore)
const { setManagedTimeout } = useTimeout()

const showTooltip: Ref<boolean> = ref(false)

onMounted(() => {
  setManagedTimeout(() => {
    showTooltip.value = true

    setManagedTimeout(() => {
      showTooltip.value = false
    }, 5000)
  }, 3000)
})

const onClick = () => {
  soundEffectsStore.toggleMuted()
  showTooltip.value = false
}
</script>

<style lang="scss" scoped>
.muteComponentContainer {
  position: relative;
}

.tooltip {
  position: absolute;
  box-sizing: content-box;
  left: 0;
  transform: translateX(-110%);
  width: 10rem;
  background-color: $grey;
  border: 1px solid #f3f3f3;
  border-radius: 0.25rem;
  padding: 0.6rem;
  z-index: 5;
  font-weight: bold;

  &::after {
    content: '';
    position: absolute;
    top: 30%;
    left: 100%;
    width: 16px;
    height: 16px;
    border: 1px solid;
    border-color: #f3f3f3 #f3f3f3 transparent transparent;

    transform: rotate(45deg) translateX(-11px);
    transform-origin: 50% 50%;
    background-color: $grey;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.sound-btn {
  border: 2px solid #7a71f9;
  background-color: white;
  color: #7a71f9;
  font-weight: 600;
  border-radius: 0.5rem;
  padding: 0.7rem 0.9rem;
  cursor: pointer;
  font-size: 1rem;
}
.sound-btn.active {
  background-color: #7a71f9;
  color: white;
  .icon {
    color: white;
  }
}

.sound-btn .icon {
  padding: 0px 0.25rem;
}
</style>
